import React from 'react';
import "./CloseEventModal.scss"
import EditMessage from './EditMessage';
import { CloseIcon } from '../svg/index';

const CloseEventModal = ({ close, proceed, aircraftdetail, handlemessage, isValidComment }) => {
   

    return (
        <div className='modal'>
            <div className='modal-content'>
                <div className='text-wrapper'>
                    <div className="header-wrapper">
                        <h2 className="header header_new">Close event for {aircraftdetail} </h2>
                        <button className="close-icon" onClick={close}>
                            <CloseIcon />
                        </button>
                        <p className="reopen-text reopen_new">Do you want to close this event?</p>
                        <div key="reopenMessage" className="reopen-comment-fullWidth">
                            <EditMessage key="reopenMessageBox" className="edit-comment-box" onMessageDataChange={handlemessage} initialMessage={""} forModal={true} type={"closing"} />
                        </div>
                    </div>
                    <div className="button-wrapper-start">
                        <auro-button class={
                            isValidComment
                                ? ""
                                : "disabled"
                        } onClick={proceed}>
                            <span className="btnlabel-white">Yes, Close Event</span>
                        </auro-button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CloseEventModal;